import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { EmployeeTransitPass } from './transitPassTypes'

export interface TransitPassState {
  programUpdated: boolean
  employeeTransitPasses: EmployeeTransitPass[] | null
}

const initialState: TransitPassState = {
  programUpdated: false,
  employeeTransitPasses: null,
}

const transitPassSlice = createSlice({
  name: 'transitPass',
  initialState,
  reducers: {
    toggleTransitPassProgramUpdated(state) {
      state.programUpdated = !state.programUpdated
    },
    getEmployeeTransitPassesSuccess(
      state,
      action: PayloadAction<EmployeeTransitPass[]>
    ) {
      state.employeeTransitPasses = action.payload
    },
    createEmployeeTransitPassSuccess(
      state,
      action: PayloadAction<EmployeeTransitPass>
    ) {
      const nextPass = action.payload
      const existing = state.employeeTransitPasses ?? []
      const withoutAgency = existing.filter(
        (pass) => pass.transitAgency !== nextPass.transitAgency
      )
      state.employeeTransitPasses = [...withoutAgency, nextPass]
    },
  },
})

export const transitPassReducer = transitPassSlice.reducer
export const transitPassReducers = transitPassSlice.actions
